module.exports = __webpack_public_path__ + "img/btn_heng_1.1730de29.png";